import Vue from "vue";
// 删除节点dom
const remove = (el) => el.parentNode.removeChild(el);
Vue.directive('auth', {
    inserted: (el, binding, vNode) => {    
      const { $root: vm } = vNode.context
      // 获取当前用户的岗位信息,isMaster为true为主账号
      // 获取用户信息下partnerPostion，渠道管理员：0,客户经理：1，客户经理主管：2，财务专员：3
      const { isMaster,partnerPostion } = vm.$store.state.main.userInfo;
      // 获取传入的权限码value（string or array）和修饰符modifiers
      let { value, modifiers } = binding;
      console.log("岗位名称:",partnerPostion);
      // 如果是主账号，则拥有所有权限
      if (isMaster){
        return false;
      }
      // 判断条件：当传入的值不是数组或者字符串时，直接隐藏元素
      if (
        !(
          typeof value === 'string' || typeof value === 'number' ||
          value instanceof Array
        ) ||
        !value
      ) {
        remove(el)
        return console.error('please set the value to a string or array.')
      }
      
      // 判断条件：如果传入的权限码是string则转化成数组
      if (typeof value === 'string' || typeof value === 'number') {
        value = [value]
      }
  
      /**
       * 判断条件
       *  -修饰符为 every时 value数组只要有一个元素不存在partnerPostion岗位内，隐藏元素
       *  -修饰符为 some或者没有时，value数组所有元素都不存在partnerPostion岗位内，隐藏元素
       */ 
      if (
        (
          modifiers.every &&
          value.some(v => !partnerPostion.includes(v))
        ) ||
        (
          !modifiers.every &&
          value.every(v => !partnerPostion.includes(v))
        )
      ) {
        remove(el)
      }
    }
});
Vue.directive('loadmore', {
  bind (el, binding, vnode) {
    const SELECTWRAP_DOM = el.querySelector('.el-select-dropdown .el-select-dropdown__wrap')
    SELECTWRAP_DOM.addEventListener('scroll', function () {
      const CONDITION = this.scrollHeight - this.scrollTop <= this.clientHeight
      if (CONDITION) {
        binding.value()
      }
    })
  }
})


// WEBPACK FOOTER //
// ./src/common/directive/index.js